<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div>
<!--            <div class="top_tools_div">-->
            <van-sticky>
                <div style="background-color: white; box-shadow: 1px 1px 5px #999999;">
                    <Wp_search_model ref="Wp_search_model"
                                     :search-value="search_value"
                                     font-color=""
                                     :common-transparent="$common.transparent"
                                     @clickToSearch="clickToSearch"
                                     @getSearchValue="getSearchValue"
                    ></Wp_search_model>
                </div>
            </van-sticky>

            <Wp_tb_select_base ref="Wp_tb_select_base"
                               :offset-top="52"
                               @onLoad="onLoad"
                               @clearSearch="clearSearch"
            ></Wp_tb_select_base>
        </div>
    </van-pull-refresh>
</template>

<script>
    import Wp_search_model from "../../custom/Wp_search_model";
    import Wp_tb_select_base from "./Wp_tb_select_base";
    export default {
        name: "Wp_tb_select",
        components: {Wp_tb_select_base, Wp_search_model},
        data(){
            return{
                search_value: '',
                //下拉刷新结束
                isLoading: false,
            }
        },

        created() {
        },

        methods:{

            clearSearch(){
                this.search_value = "";
                this.$refs.Wp_search_model.search_value = "";
            },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.$refs.Wp_tb_select_base.onRefresh();
            },


            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                this.$refs.Wp_tb_select_base.clickToSearch();
                this.searchInputClick('0');
            },

            searchInputClick(id){
                this.$refs.Wp_tb_select_base.searchInputClick(id);
            },

            getSearchValue(value){
                this.$refs.Wp_tb_select_base.getSearchValue(value);
            },

            onLoad(){
                //关闭下拉刷新
                this.isLoading = false;
            },
        }
    }
</script>

<style scoped>
    .top_tools_div{
        width: 100%;
        min-height: 80px;
        position: fixed;
        top: 0px;
        z-index: 1999;
        /*box-shadow: 0px 1px 5px #999*/
    }

    .checkbox_sort_div_hide {
        max-height: 0px;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        overflow: hidden;
    }

    .checkbox_sort_div_show {
        overflow: hidden;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        max-height: 100px;
    }
</style>